import React from "react";
import { Link } from "react-router-dom";

import TextileBackground from "../../components/TextileBackground";
import CinematicSection from "../../components/CinematicSection";
import CustomNavbar from "../../components/Navbar";
import Reveal from "../../components/Reveal";
import FooterLinks from "../../components/FooterLinks";
import Footer from "../../components/Footer";
import LookCard from "../../components/LookCard";
import catalogue from "../../data/catalogue";

export default function CatalogueWomen() {
  const items = catalogue.women;

  return (
    <TextileBackground>
      <CustomNavbar />

      <CinematicSection zIndex={10} className="bg-cream-100/60">
        <div className="px-6 max-w-3xl mx-auto text-center">
          <Reveal>
            <p className="font-accent italic text-maroon-700 text-base tracking-[0.3em] uppercase mb-3">
              The Edit
            </p>
          </Reveal>
          <Reveal delay={150}>
            <h1 className="font-heading text-maroon-800 text-3xl sm:text-5xl font-semibold uppercase">
              Womenswear
            </h1>
          </Reveal>
          <Reveal delay={300}>
            <p className="font-body text-maroon-900/90 text-sm sm:text-base leading-relaxed mt-4">
              Kurtis, tunics, short kurti tops and bottoms made to consistent quality standards.
            </p>
          </Reveal>
          <Reveal delay={400}>
            <Link
              to="/catalogue"
              className="inline-block mt-4 text-xs font-accent text-maroon-700/85 hover:text-maroon-700 hover:underline"
            >
              &larr; Back to Catalogue
            </Link>
          </Reveal>
        </div>
      </CinematicSection>

      <CinematicSection zIndex={20} className="bg-cream-100/60" overflowY="auto">
        <div className="max-w-5xl mx-auto px-6 py-10 w-full">
          <div className="columns-2 md:columns-3 gap-6">
            {items.map((item, i) => (
              <LookCard key={item.id} item={item} index={i} />
            ))}
          </div>
        </div>
      </CinematicSection>

      <FooterLinks />
      <Footer />
    </TextileBackground>
  );
}
